import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {SharedService} from "../../shared/shared.service";
import {SharedDataService} from "../../shared/shared-data.service";
import {DtoBranchUser} from "../../shared/models/DtoBranchUser";
import {DtoCashbook} from "./models/DtoCashbook";
import {CashbookService} from "./cashbook.service";
import {Angular5Csv} from "angular5-csv/Angular5-csv";


@Component({
    selector: 'app-administration-cashbook',
    template: require('./cashbook.component.html'),
    styles: [require('./cashbook.component.css')]
})

@AutoUnsubscribe()
export class CashbookComponent implements OnInit {
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    filterHeaderConfig: PageHeaderBarConfig = {
        title: 'INSTELLINGEN',
        buttonDefinition: [
            {
                description: 'BEKIJKEN',
                isSmall: false,
                clickEventType: 'search'
            }
        ]
    };
    pshbConfig: PageSubheaderBarConfig = {
        title: 'KASBOEK',
        buttonDefinition: [
            {
                description: 'EXPORT BOEKHOUDING',
                isSmall: false,
                clickEventType: 'export'
            },
            {
                description: 'EXCEL',
                isSmall: false,
                clickEventType: 'excel'
            }
        ]
    };
    filterForm: FormGroup = this.fb.group({
        userId: 0,
        periodId: 1,
        from: null,
        untill: null
    });
    branches: DtoBranchUser[];
    periodDisabled: boolean;
    periodItems: Array<{ text: string, value: number }> = [
        {text: "Vandaag", value: 0},
        {text: "Deze week", value: 1},
        {text: "Deze maand", value: 2},
        {text: "Dit jaar", value: 3},
        {text: "Laatste 2 jaar", value: 4},
        {text: "Variabele periode", value: 5}
    ];
    data: DtoCashbook[];
    excelFilename: string;
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'bookDate',
            label: 'Datum',
            type: 'string',
            width: '130px',
            rowColor: 'rowColor'
        },
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '*',
            rowColor: 'rowColor'
        },
        {
            key: 'ledgerAccount',
            label: 'Grootboek',
            type: 'string',
            width: '100px',
            rowColor: 'rowColor'
        },
        {
            key: 'credit',
            label: 'Inkomsten',
            type: 'color',
            width: '120px',
            color: 'creditColor',
            textColor: 'creditTextColor',
            rowColor: 'rowColor'
        },
        {
            key: 'debit',
            label: 'Uitgaven',
            type: 'color',
            width: '120px',
            color: 'debitColor',
            textColor: 'debitTextColor',
            rowColor: 'rowColor'
        },
        {
            key: 'btwDesc',
            label: 'BTW',
            type: 'string',
            width: '100px',
            rowColor: 'rowColor'
        },
        {
            key: 'saldo',
            label: 'Saldo',
            type: 'string',
            width: '120px',
            format: '{0:c}',
            rowColor: 'rowColor'
        }
    ];

    constructor(private breadcrumService: BreadcrumService,
                private fb: FormBuilder,
                private ds: CashbookService,
                private ss: SharedService,
                private sds: SharedDataService) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'administratie', isLastStep: false },
            { text: 'kasboek', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');

        this.filterForm.get('periodId').valueChanges.subscribe(newVal => {
            this.setFilterPeriod(newVal);
        });

        this.setFilterPeriod(1);

        this.sds.getBranchesWithAll().subscribe((res: DtoBranchUser[]) => {
            setTimeout(() => {
                this.branches = res;
                this.filterForm.patchValue({['userId']: this.branches[1].id});
                this.loadData();
            });
        });
    }

    loadData() {
        this.excelFilename = `kasboek-${this.getSelectedBranchName()}-${this.ss.formatDate(this.filterForm.get('from').value)}_${this.ss.formatDate(this.filterForm.get('untill').value)}.xlsx`;
        this.grid.clearData();
        this.data = [];
        this.ds.getCashbook({
            userId: this.filterForm.get('userId').value,
            from: this.filterForm.get('from').value,
            untill: this.filterForm.get('untill').value
        }).subscribe((res: DtoCashbook[]) => {
            this.data = res;
            if (this.data.length > 0) {
                this.grid.showData(this.data);
            }
        });
    }

    getSelectedBranchName() {
        if (this.branches) {
            return this.branches.find(x => x.id == this.filterForm.get('userId').value).companyName;
        }
        return '';
    }

    phbBtnClicked(event) {
        if (event == 'search') {
            this.loadData();
        }
    }

    pshbBtnClicked(event) {
        if (event == 'excel') {
            this.grid.saveAsExcel();
        } else if (event == 'export') {
           this.exportCashbook();
        }
    }

    exportCashbook() {
        let exportData = [];
        this.data.forEach(item => {
            if (item.description != "Beginsaldo" && item.description != "Geen dagafsluiting" && item.bookDate != '') {
                exportData.push({
                    col1: item.ledgerAccount ? item.ledgerAccount : '',
                    col2: item.agencyNo,
                    col3: item.companyName,
                    col4: item.bookDate,
                    col5: item.lineAmount.toFixed(2).replace('.',','),
                    col6: item.btwDesc == '0,00%' || item.btwDesc == null ? '00' : item.btwCode ? item.btwCode : '00',
                    col7: item.btwDesc ? item.btwDesc != '0,00%' ? 'inclusief' : 'geen BTW' : 'geen BTW',
                    col8: item.credit ? 'credit' : 'debit',
                    col9: item.mutationDescription ? item.mutationDescription : item.description
                });
            }
        });
        let options = {
            fieldSeparator: ';',
            quoteStrings: '',
            decimalseparator: ',',
            showLabels: true,
            showTitle: false,
            title: 'Your title',
            useBom: true,
            noDownload: false,
            headers: ["grootboekrekening", "filiaalnummer", "filiaalnaam", "datum", "bedrag", "btw code", "btw opm", "type", "omschrijving"]
        };

        new Angular5Csv(exportData, `kasboek-${this.getSelectedBranchName()}-${this.ss.formatDate(this.filterForm.get('from').value)}_${this.ss.formatDate(this.filterForm.get('untill').value)}`, options);
    }

    setFilterPeriod(periodKind: number) {
        if (periodKind == 0) {
            this.periodDisabled = true;
            this.filterForm.patchValue({['from']: this.ss.getCurrentDate()});
            this.filterForm.patchValue({['untill']: this.ss.getCurrentDate()});
        } else if (periodKind == 1) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfWeek(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.addDaysToDate(this.ss.getFirstDayOfWeek(this.ss.getCurrentDate()), 6) });
        } else if (periodKind == 2) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfMonth(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.getLastDayOfMonth(this.ss.getCurrentDate()) });
        } else if (periodKind == 3) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfYear(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.getLastDayOfYear(this.ss.getCurrentDate()) });
        } else if (periodKind == 4) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfYear(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.addYearsToDate(this.ss.getLastDayOfYear(this.ss.getCurrentDate()), 1) });
        } else if (periodKind == 5) {
            this.periodDisabled = false;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/administration/cashbook/cashbook.component.ts